import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-weight-bold" }
const _hoisted_2 = { class: "font-weight-bold" }

import { useDataStore } from "@/store/data-store";
import { CoordinateSystem } from "@/swagger/models/CoordinateSystem";
import { reactive } from "vue";
import VueSelect from "vue-select";


export default /*#__PURE__*/_defineComponent({
  __name: 'CoordinateSystemPicker',
  props: {
	value: {
		type: Object
	},
	disabled: {
		type: Boolean,
		default: false
	}
},
  emits: ["input"],
  setup(__props, { emit }) {

const props = __props;

const dataStore = useDataStore();





let data = reactive({
	coordinateSystem: null as CoordinateSystem,
	coordinateSystems: [] as CoordinateSystem[]
})

function onSelectionChanged(event) {
	console.log("Event", event);
	emit("input", event);
}

async function onSearchCoordinateSystem(search) {
	data.coordinateSystems = await dataStore.getCoordinateSystems(search);
}

onSearchCoordinateSystem(props.value ?? "");


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueSelect), {
    class: "underlined",
    disabled: _unref(props).disabled,
    value: _unref(props).value,
    filterable: false,
    options: _unref(data).coordinateSystems,
    onSearch: onSearchCoordinateSystem,
    "onOption:selected": _cache[0] || (_cache[0] = ($event: any) => (onSelectionChanged($event)))
  }, {
    "selected-option": _withCtx(({ epsgCode, description }) => [
      _createElementVNode("b", _hoisted_1, _toDisplayString(epsgCode), 1),
      _createTextVNode(" (" + _toDisplayString(description) + ") ", 1)
    ]),
    option: _withCtx(({ epsgCode, description }) => [
      _createElementVNode("b", _hoisted_2, _toDisplayString(epsgCode), 1),
      _createTextVNode(" (" + _toDisplayString(description) + ") ", 1)
    ]),
    _: 1
  }, 8, ["disabled", "value", "options"]))
}
}

})